import { render } from "./JoinPublication.vue.js?vue&type=template&id=25bfb7cc!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./JoinPublication.vue?vue&type=template&id=25bfb7cc"
import script from "./JoinPublication.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./JoinPublication.vue?vue&type=script&lang=js"
export * from "./JoinPublication.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./JoinPublication.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/JoinPublication.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "25bfb7cc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('25bfb7cc', __exports__)) {
    api.reload('25bfb7cc', __exports__)
  }
  
  module.hot.accept("./JoinPublication.vue.js?vue&type=template&id=25bfb7cc!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./JoinPublication.vue?vue&type=template&id=25bfb7cc", () => {
    api.rerender('25bfb7cc', render)
  })

}


export default __exports__